export const getActivitiesOffsetAndLimit = (
  pageNumber: number,
  numberOfActivitiesToReturn: number,
) => {
  const limit = pageNumber * numberOfActivitiesToReturn;
  const offset = limit - numberOfActivitiesToReturn;

  return { offset, limit };
};
